document.addEventListener('DOMContentLoaded', () => {
  const maxSymbolCount = 210;
  const jsonScript = document.getElementById('ab-script');
  const data = JSON.parse(jsonScript.textContent);

  const expertList = document.querySelector('.experts__list-js');
  const expertsItems = Array.from(
    expertList.querySelectorAll('.experts__item-js')
  );

  const expertsDescriptionTextObject = {};

  expertsItems.forEach((item, index) => {
    const expertCard = item.querySelector('.expert__card-js');
    const id = expertCard.getAttribute('id');
    const authorBox = expertCard.querySelector('.author__box-js');

    let authorDescription = authorBox.querySelector('.author__description-js');
    const expertsDescriptionText = data[index].short_description ? data[index].short_description.slice(maxSymbolCount) : authorDescription.textContent.slice(maxSymbolCount);
    const expertsSlicedDescriptionText = data[index].short_description ? data[index].short_description.slice(0,maxSymbolCount) : authorDescription.textContent.slice(0,maxSymbolCount);

    authorDescription.textContent = expertsSlicedDescriptionText.length >= maxSymbolCount ? `${expertsSlicedDescriptionText}...`: expertsSlicedDescriptionText;

    expertsDescriptionTextObject[id] = {
      slicedText: expertsSlicedDescriptionText,
      fullText:  expertsSlicedDescriptionText.length >= maxSymbolCount ?  expertsDescriptionText : expertsSlicedDescriptionText,
    };
  });

  function handleExpertCardHover(event, isMouseOver) {
    const card = event.target.closest('.expert__card-js');

    if (!card) {
      return;
    }

    const key = card.getAttribute('id');

    const authorBox = card.querySelector('.author__box-js');
    const authorButton = card.querySelector('.author__button-js');
    const authorDescription = authorBox.querySelector(
      '.author__description-js'
    );

    if (isMouseOver) {
      authorDescription.innerHTML = `${expertsDescriptionTextObject[key].fullText} <span class="author__description-fulltext">${expertsDescriptionTextObject[key].fullText >= maxSymbolCount ? expertsDescriptionTextObject[key].fullText : ""}</span>`;
      const authorFullDescription = authorDescription.querySelector(
        '.author__description-fulltext'
      );

      authorButton.style.display = 'block';
      authorBox.classList.add('author-box__anim');

      authorFullDescription.classList.add(
        'author__description--show-description'
      );
    } else {
      authorBox.classList.remove('author-box__anim');
      authorDescription.innerHTML = expertsDescriptionTextObject[key].slicedText.length >= maxSymbolCount ? `${expertsDescriptionTextObject[key].slicedText}...` : expertsDescriptionTextObject[key].slicedText;
      authorButton.style.display = 'none';
    }
  }

  function handleCardClick(event) {
    const card = event.target.closest('.expert__card-js');

    if (!card) {
      return;
    }

    const cardId = card.getAttribute('id');

    const modalBackdrop = document.querySelector('.backdrop');
    const modal = document.querySelector('.modal');
    const modalInfo = modal.querySelector('.modal-info');
    const modalButton = document.querySelector('.modal-button');

    modalBackdrop.style.display = 'block';
    modal.style.display = 'block';
    document.body.style.overflowY = 'hidden';

    data.map((item) => {
      if (item.id === cardId) {
        modalInfo.innerHTML = `
        <ul class="expert__modal-list">
          <li class="expert__modal-item">
            <p class="expert__modal-role">${item.role}</p>  
          <li>
          <li class="expert__modal-item">
            <h2 class="expert__modal-fullname">${item.fullname}</h2>  
          <li>
          <li class="expert__modal-item">
            <p class="expert__modal-description">${item.description}</p>  
          </li>
        </ul>
       `;
      }
    });

    modalBackdrop.addEventListener('click', (event) => {
      if (!event.target.closest('.modal')) {
        modalBackdrop.style.display = 'none';
        modal.style.display = 'none';
        document.body.style.overflowY = 'scroll';
      }
    });

    modalButton.addEventListener('click', () => {
      modalBackdrop.style.display = 'none';
      modal.style.display = 'none';
      document.body.style.overflowY = 'scroll';
    });
  }

  expertList.addEventListener('click', handleCardClick);

  function trackScreenWidth() {
    const width = window.innerWidth;
  
    if (width <= 800) {
      expertList.removeEventListener('mouseover', handleExpertCardHover);
      expertList.removeEventListener('mouseout', handleExpertCardHover);
    } else {
      expertList.addEventListener('mouseover', (event) =>
        handleExpertCardHover(event, true)
      );
      expertList.addEventListener('mouseout', (event) =>
        handleExpertCardHover(event, false)
      );
    }
  }  
  trackScreenWidth()
  window.addEventListener('resize', trackScreenWidth);  
});
